import { render, staticRenderFns } from "./SmartSecurityPage.vue?vue&type=template&id=352707a3&scoped=true"
import script from "./SmartSecurityPage.vue?vue&type=script&lang=js"
export * from "./SmartSecurityPage.vue?vue&type=script&lang=js"
import style0 from "./SmartSecurityPage.vue?vue&type=style&index=0&id=352707a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352707a3",
  null
  
)

export default component.exports